import { Vue, Component, Prop } from 'vue-property-decorator'
import { format } from 'fecha'
import Article from '~/types/api/news/Article'
import SfImageElement from '~/components/element/SfImageElement'
import loc from '~/utils/loc'
import MarkingAd from '~/components/element/MarkingAd'

@Component
export default class NewsItem extends Vue {
  @Prop({ required: true, type: Object })
  readonly article!: Article

  get time () {
    if (this.article.updatedAt) {
      return format(new Date(this.article.placementDate), 'DD.MM.YYYY')
    }
  }

  render () {
    const location = loc(this.$store, {
      name: 'news-code',
      params: { code: this.article.code }
    })
    return (
      <div class="news-item">
        <nuxt-link to={location} class="news-item__image">
          <SfImageElement {...{
            props: {
              img: this.article.image
            }
          }} />
        </nuxt-link>
        <div class="news-item__marking-Ad">
          {this.article.marking?.id &&
              <MarkingAd {...{
                props: {
                  info: this.article.marking
                }
              }}/>
          }
        </div>
        <div class="news-item__subtitle">
          Статья
        </div>
        <nuxt-link to={location} class="news-item__link">
          {this.article.title}
        </nuxt-link>
        {this.article.placementDate &&
          <div class="news-item__time">
            {this.time}
          </div>
        }
      </div>
    )
  }
}
